var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97478 0.872657C9.94958 0.811699 9.90686 0.759588 9.85204 0.722917C9.79721 0.686247 9.73273 0.666668 9.66677 0.666657H0.333442C0.267428 0.666539 0.202866 0.686024 0.14794 0.722643C0.0930134 0.759262 0.0501971 0.811366 0.0249187 0.872348C-0.000359642 0.93333 -0.0069617 1.00045 0.00594949 1.06518C0.0188607 1.12992 0.0507036 1.18937 0.0974415 1.23599L4.76411 5.90266C4.79507 5.9337 4.83186 5.95833 4.87235 5.97513C4.91285 5.99194 4.95626 6.00059 5.00011 6.00059C5.04395 6.00059 5.08737 5.99194 5.12786 5.97513C5.16836 5.95833 5.20514 5.9337 5.23611 5.90266L9.90277 1.23599C9.94936 1.18934 9.98107 1.12992 9.99389 1.06524C10.0067 1.00057 10.0001 0.93355 9.97478 0.872657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDropdown);
export default __webpack_public_path__ + "static/media/whiteDropdown.0c15d2dc7cf7082cdeb4be9467b83ee9.svg";
export { ForwardRef as ReactComponent };